// Layout state
const state = {
  layouts: {},
  active: {},
  newLayout: {
    name: '',
    json: ''
  },
  perPage: '25',
  currentPage: 1,
  totalPageCount: 1,
  revisions: [],
  shortRevisionList: [],
  activeRevisionId: null
}

export default state
